import { Component, OnInit, HostListener, DoCheck } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { environment } from "src/environments/environment";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { filter } from "rxjs/operators";
declare let $: any;
declare var gtag: any;
import * as url from "url";
import Swal from "sweetalert2";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, DoCheck {
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  public identity: any;
  public year: number = Date.now();
  public toggleTooltip = false;
  public itemMenuSelected: number;
  public request = null;
  public environment: string;
  public dataMenu = [
    {
      alt: "Cargue Cartera",
      img: "assets/img/icons/icon-charge.svg",
      path: "/carga",
      icon: 'far fa-file-excel',
      active: true
    },
    {
      alt: "Reportes",
      img: "assets/img/icons/icon-reports.svg",
      path: "/reportes",
      icon: 'fas fa-chart-pie',
      active: true
    },
    {
      alt: "Pagos y reintegros",
      img: "assets/img/icons/icon-refunds.svg",
      path: "/pagos",
      icon: 'fas fa-hand-holding-usd',
      active: true
    },
  ];

  public title = "CoviRecupera";
  public isLogged: boolean;
  public analytics: any;
  public isShow: boolean;
  public footerShow: any;
  public topPosToStartShowing = 100;
  @HostListener("window:scroll")
  checkScroll() {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    this.isShow = scrollPosition >= this.topPosToStartShowing ? true : false;
  }

  constructor(
    public router: Router,
    public auth: AuthService,
    private toastr: ToastrService
  ) {
    this.analyticsConfig();
  }

  ngOnInit() {
    this.analytics = JSON.parse(localStorage.getItem("identityCVE"));
    this.environment = environment.production ? 'Prod' : 'Dev';
    console.info(this.environment, new Date(2026, 4, 21, 23, 0, 0), 'AWS - Ambiente PROD Nueva apiPayzen y Apireports');
  }

  ngDoCheck() {
    this.identity = JSON.parse(localStorage.getItem("identityCVE"));
    this.analytics = JSON.parse(localStorage.getItem("identityCVE"));
    const { pathname } = url.parse(this.router.url);
    this.isLogged = pathname == '/login' ? false : true;
  }

  analyticsConfig() {
    const navEndEvents$ = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    );

    navEndEvents$.subscribe((event: NavigationEnd) => {
      gtag("config", "UA-166835786-2", {
        page_path: event.urlAfterRedirects
      });
    });
  }

  mouseIn($event: any, idx: number) {
    this.toggleTooltip = true;
    this.itemMenuSelected = idx;
  }

  mouseOut($event: any) {
    this.toggleTooltip = false;
    this.itemMenuSelected = undefined;
  }

  // TODO: Cross browsing
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }

  logOut() {
    (window as any).gtag("event", "cerrar_sesion", {
      event_category: `${this.analytics.v_tipo_documento} ${this.analytics.v_documento}`,
      event_label: ""
    });
    localStorage.clear();
    this.isLogged = false;
    this.auth.hide();
    this.router.navigate(["/login"]);
  }

  toastNotification(titulo: string, descripcion: string) {
    this.toastr.success(titulo, descripcion);
  }

  handleShowModal(path: string) {
    return;
    if (path === "/reportes") {
      Swal.fire({
        imageUrl: "assets/popup/reportes.png",
        imageHeight: 500,
        showCloseButton: true,
        showConfirmButton: false,
        allowOutsideClick: false,
        focusConfirm: false,
      });
    }
  }
}
